export const handleClickCopy = async (text: string, setIsCopied: (b: boolean) => void) => {
  await navigator.clipboard.writeText(text);
  setIsCopied(true);
  setTimeout(() => {
    setIsCopied(false);
  }, 1500);
};
